module.exports = __webpack_public_path__ + "img/other3x.562f24b2.png";